import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SettingButtonConfig, ToggleButtonItem } from './toggle-button-item.type';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';

@Component({
  selector: 'setting-button',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenu,
    MatMenuTrigger,
    MatMenuItem,
  ],
  templateUrl: './setting-button.component.html',
})
export class SettingButtonComponent {
  @Input() config: Partial<SettingButtonConfig> = {};

  private defaultConfig: SettingButtonConfig = {
    selectedObject: null,
    selectedObjectIdField: 'id',
    showButton: false,
    showToggleButton: false,
    settingsLabel: 'Settings',
    settingsRoute: '',
    settingsIcon: 'heroicons_outline:cog-6-tooth',
    toggleButtonMenuItems: [],
    buttonColor: 'accent',
    openInNewWindow: true,
  };

  dropdownOpen = false;

  constructor(private router: Router) {
  }

  get mergedConfig(): SettingButtonConfig {
    return { ...this.defaultConfig, ...this.config };
  }

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;
  }

  openSettings(): void {
    this.dropdownOpen = false;
    const config = this.mergedConfig;

    if (!config.settingsRoute) return;

    const url = config.settingsRoute;

    if (config.openInNewWindow) {
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(url);
    }
  }

  test() {
    console.log('test');
  }

  onMenuItemClick(item: ToggleButtonItem): void {
    this.dropdownOpen = false;
    const config = this.mergedConfig;

    if (!item.routeLink) return;

    const objectId = this.getObjectId();
    let url = item.routeLink;
    let queryParams: { [key: string]: string } = {};

    if (item.queryParams) {
      queryParams = { ...item.queryParams };
    }

    if (objectId && item.useObjectIdAsParam) {
      const paramName = item.paramName || 'id';
      queryParams[paramName] = objectId.toString();
    }

    if (config.openInNewWindow) {
      const queryString = Object.keys(queryParams).length > 0
        ? '?' + Object.entries(queryParams).map(([key, value]) => `${key}=${value}`).join('&')
        : '';
      window.open(url + queryString, '_blank');
    } else {
      this.router.navigate([url], { queryParams });
    }
  }

  private getObjectId(): string | number | null {
    const config = this.mergedConfig;
    if (!config.selectedObject) return null;

    const fieldPath = config.selectedObjectIdField.split('.');
    let value = config.selectedObject;

    for (const field of fieldPath) {
      value = value?.[field];
      if (value === undefined || value === null) {
        return null;
      }
    }

    return value;
  }

  onDocumentClick(): void {
    this.dropdownOpen = false;
  }

  get hasToggle(): boolean {
    return this.mergedConfig.showToggleButton && this.mergedConfig.toggleButtonMenuItems?.length > 0;
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any
  {
    return item.id || index;
  }

}
